import { MenuItem, SubMenu } from 'ant-design-vue';
import { computed, h, isVNode } from 'vue';
export default {
  name: 'XMenuItem',
  components: {
    AMenuItem: MenuItem,
    ASubMenu: SubMenu
  },
  props: {
    name: {
      type: [String, Number],
      default: null
    },
    item: {
      type: {
        title: '',
        icon: '',
        name: '',
        children: []
      },
      required: true
    }
  },
  emits: ['item-click'],
  setup(props, context) {
    const handleItemClick = item => {
      context.emit('item-click', item);
    };
    const handleClick = () => {
      context.emit('item-click', props.item);
    };
    const itemIcon = computed(() => {
      const {
        icon
      } = props.item || {};
      if (!icon) return null;
      if (typeof icon === 'string') {
        return h('span', {
          class: icon
        });
      }
      if (isVNode(icon)) {
        return () => icon;
      }
      if (typeof icon === 'object' && icon.render) {
        return h(icon);
      }
      if (typeof icon === 'function') {
        return h(icon);
      }
      return null;
    });
    return {
      handleItemClick,
      handleClick,
      itemIcon
    };
  }
};